import styled from "styled-components";
import { LiveCasinoGridItemDrawDefaultBox } from "./live-casino-grid-item-draw.default.box";

export const LiveCasinoGridItemDrawSICisBox = styled(LiveCasinoGridItemDrawDefaultBox)`
    &:first-child {
          color: ${props => props.theme.colors.moneyColor};
    }
     
    ${({theme}) => theme.font.presets.medium};
`;
